import React from 'react'
import './footer.css'
import {BsWhatsapp, BsLinkedin} from 'react-icons/bs'

const Footer = () => {
  return (
    <footer>
      <a href='#' className='footer__logo'>OBIORA</a>
      <ul className='permalinks'>
        <li><a href='#'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#services'>Services</a></li>
        <li><a href='#portfolio'>Portfolio</a></li>
        <li><a href='#testimonials'>Testimonials</a></li>
        <li><a href='#contact'>Contact</a></li>
      </ul>

  
      <div className='footer__socials'>
         <a href='https://www.linkedin.com/in/obiora-ejiofor-282496177/'><BsLinkedin/></a>
         <a href='https://api.whatsapp.com/send?phone+2348062329708'><BsWhatsapp/></a>
      </div>

      <div className='footer__copyright'>
        <small>&copy; OBIORA. All right reserved</small>
      </div>
    </footer>
  )
}

export default Footer